<template>
    <NuxtLink
        v-if="venue.slug"
        :to="`/venues/${venue?.slug}`"
        class="event-venue"
    >
        {{ formattedLabel }}
    </NuxtLink>
</template>

<script setup lang="ts">
const props = defineProps<{
    venue: VenueRelation;
}>();

const formattedLabel = computed(() => {
    return props.venue.name + (props.venue?.city ? `, ${props.venue.city.name}` : '');
});
</script>
